import "./LabeledMeasurement.css";

const LabeledMeasurement = ({ label, value, unit }) => {
  return (
    <div className="LabeledMeasurement-container">
      <span className="App-text-medium LabeledMeasurement-label">{label}:</span>
      <div className="App-text-medium LabeledMeasurement-measurement-section">
        <span className="App-text-medium LabeledMeasurement-value">
          {value}
        </span>
        <span className="App-text-medium LabeledMeasurement-unit"> {unit}</span>
      </div>
    </div>
  );
};

export default LabeledMeasurement;
